import { app } from 'config/app';

export function key(...keys: string[]) {
	return `${app.id.toLowerCase()}:${keys.join('-')}`;
}
